import React from "react";
import { useParams } from "react-router-dom";

import OrganizationDetail from "../organization/OrganizationDetail";
import EatsAdminLayout from "./EatsAdminLayout";

const EatsAdminOrganizationDetailPage = () => {
  const { organizationId } = useParams();

  return (
    <EatsAdminLayout activeTab="organizations" flushMain>
      <OrganizationDetail organizationId={organizationId} embeddedInAdmin />
    </EatsAdminLayout>
  );
};

export default EatsAdminOrganizationDetailPage;
